export default __webpack_public_path__ + "static/media/shm_logo.b470e6ef.png";